import defaultAttributes from '../defaultAttributes';

const Sigma = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M18 7V4H6l6 8-6 8h12v-3' }]],
];

export default Sigma;
